import { getRequest, putRequest, postRequest } from "../../api/methodsCfg";
import { getLatLongFromAddress } from "../../utils/gis";

export const getAllRestaurants = async () => {
  const response = await postRequest("/restaurant/all");
  return response;
};

export const getAllRestaurantsByBusinessDeveloper = async (userId) => {
  const response = await getRequest(
    `/restaurant/allByBusinessDeveloper/${userId}`
  );
  return response;
};

export const getRestaurantsCount = async () => {
  const response = await getRequest("/restaurant/count");
  return response;
};

export const getRestaurant = async (id) => {
  const response = await getRequest(`/restaurant/details/${id}`);
  return response;
};

export const getRestaurantOrders = async (id) => {
  const response = await getRequest(`/restaurant/orders/${id}`);
  return response;
};

export const updateRestaurantSettingsByAdmin = async (
  restaurantId,
  payload
) => {
  let x,
    y = null;
  try {
    const coordinates = await getLatLongFromAddress(
      payload.address,
      payload.city?.value?.npa,
      payload.city?.value?.label
    );
    if (!coordinates || !coordinates.latitude || !coordinates.longitude) {
      throw new Error("ADDRESS_NOT_FOUND");
    }
    x = coordinates.latitude;
    y = coordinates.longitude;
  } catch (error) {
    // Re-throw with a user-friendly error message
    if (error.message === "ADDRESS_NOT_FOUND") {
      throw new Error("ADDRESS_NOT_FOUND");
    }
    throw error;
  }
  const cleanPayload = {
    ...payload,
    x,
    y,
    cityId: !!payload.city?.value ? payload.city.value.cityId : payload.cityId,
    consumptionmodes: payload.consumptionmodes?.map(
      (mode) => mode.value?.consumptionModeId || mode.consumptionModeId
    ),
    restauranttype: payload.restauranttype.value
      ? payload.restauranttype.value.restaurantTypeId
      : payload.restaurantTypeId,
    schedules: payload.schedules?.map((s) => ({
      day: s.day,
      noonStartAt: s.noon.startAt,
      noonEndAt: s.noon.endAt,
      eveningStartAt: s.evening?.startAt || null,
      eveningEndAt: s.evening?.endAt || null,
    })),
    cateringschedules: payload.cateringschedules?.map((s) => ({
      day: s.day,
      startAt: s.startAt,
      endAt: s.endAt,
    })),
    cateringpromotions: payload.cateringpromotions?.map((p) => ({
      percentage: p.percentage,
      thresholdAmount: p.thresholdAmount,
    })),
  };
  const response = await putRequest(
    `/restaurant/admin/${restaurantId}/${payload.name}`,
    cleanPayload,
    true
  );
  return response;
};

export const switchOnboardingDone = async (restaurantId) => {
  const response = await putRequest(
    `restaurant/admin/switch/onboarding/${restaurantId}`
  );
  return response;
};
